// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"520":"6c9f2836","818":"6c9f2836"}[chunkId] + ".chunk.css";
};